module.exports = __webpack_public_path__ + "static/media/send.1998e7d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/send.svg
// module id = 596
// module chunks = 0